import { resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Eintragen ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createBlock(_component_n_form, {
    ref: "formRef",
    model: _ctx.formValue,
    rules: _ctx.formRules,
    size: "large"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_form_item, {
        label: "Access key",
        path: "access_key"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_input, {
            value: _ctx.formValue.access_key,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue.access_key) = $event)),
            placeholder: ""
          }, {
            suffix: _withCtx(() => []),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_n_form_item, {
        "show-feedback": false,
        "show-label": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            type: "primary",
            block: "",
            secondary: "",
            strong: "",
            disabled: _ctx.apiStore.apiFetching,
            onClick: _ctx.signIn
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}